import React from "react";
import { UserPlus, Heart, ChatTeardropText } from "phosphor-react"; // Using Phosphor icons for placeholders

interface HowItWorksSectionProps {
  className?: string;
}

export default function HowItWorksSection({
  className,
}: HowItWorksSectionProps) {
  return (
    <section
      className={`py-16 px-4 text-center text-white ${className}`} // Removed bg-white and text-gray-800
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white">
        How Does It Work?
      </h2>
      <div className="w-[50dvw] mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Step 1 */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-[#C0123E] text-white">
          {" "}
          {/* Added text-gray-900 */}
          <div className="mb-4 text-text">
            <UserPlus size={48} weight="duotone" />
          </div>
          <h3 className="text-xl font-semibold mb-3">1. Create Your Profile</h3>
          <p className="text-base leading-relaxed">
            Sign up quickly and easily. Tell us about yourself and what you're
            looking for to help us find your perfect matches.
          </p>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-text text-white">
          {" "}
          {/* Added text-gray-900 */}
          <div className="mb-4 text-[#C0123E]/80">
            <Heart size={48} weight="duotone" />
          </div>
          <h3 className="text-xl font-semibold mb-3">2. Find Your Match</h3>
          <p className="text-base leading-relaxed">
            Browse through thousands of profiles and discover people who share
            your interests.
          </p>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-[#C0123E] text-white">
          {" "}
          {/* Added text-gray-900 */}
          <div className="mb-4 text-text">
            <ChatTeardropText size={48} weight="duotone" />
          </div>
          <h3 className="text-xl font-semibold mb-3">3. Start Chatting</h3>
          <p className="text-base leading-relaxed">
            Connect instantly with your matches through our secure and private
            chat system. Flirt, share, and have fun!
          </p>
        </div>
      </div>
    </section>
  );
}
